<app-dialog [dialogWithInput]="dialog">
    <app-product-save
            (entitySavedEvent)="onEntitySaved($event)"
            [inDialog]="true"
            [typeValue]="dialog.input.typeValue">
    </app-product-save>
</app-dialog>
